import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import { Alert, alertClasses, Box, Button, Collapse, IconButton, Link, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';

import { AWS_CLI_INSTALL_DOCS_URL } from './cliInstructionItNotes';
import { CopyableBlock } from './CopyableCliBlock';

interface InlineItNoteProps {
  title: string;
  body: string;
  message: string;
  defaultExpanded?: boolean;
  onOpenSummary: () => void;
}

const InlineItNote = ({ title, body, message, defaultExpanded = false, onOpenSummary }: InlineItNoteProps) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <Alert
      severity="info"
      icon={<SecurityOutlinedIcon />}
      sx={{ width: '100%', alignItems: 'center', [`& .${alertClasses.message}`]: { width: '100%' } }}
    >
      <Stack spacing={expanded ? 1 : 0}>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2" sx={{ width: '100%' }}>
            {title}
          </Typography>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Button
              variant="outlined"
              size="small"
              startIcon={<EmailOutlinedIcon />}
              onClick={onOpenSummary}
              sx={{ width: 'max-content' }}
            >
              Email IT summary
            </Button>
            <IconButton
              aria-label={expanded ? `Collapse ${title}` : `Expand ${title}`}
              size="small"
              onClick={() => setExpanded(!expanded)}
              sx={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 150ms ease',
              }}
            >
              <ExpandMoreIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>
        <Collapse in={expanded} unmountOnExit>
          <Stack spacing={1}>
            <Typography variant="body2">{body}</Typography>
            {title.includes('installation') ? (
              <Typography variant="body2">
                Official AWS installer page:{' '}
                <Link href={AWS_CLI_INSTALL_DOCS_URL} target="_blank" rel="noreferrer">
                  AWS CLI install guide
                </Link>
                .
              </Typography>
            ) : null}
            <Box>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                Message to forward
              </Typography>
              <CopyableBlock text={message} copyButtonAriaLabel="Copy IT message" />
            </Box>
          </Stack>
        </Collapse>
      </Stack>
    </Alert>
  );
};

export default InlineItNote;
